import { gtmAffiliateProductClick, gtmViewAffiliateSection } from './gtmAffiliate';
export { buildGtagBootstrapScript } from './gtagBootstrap';
export {
  buildConnectEmailSuccessParams,
  buildSignUpSuccessParams,
  normaliseForStatsig,
} from './gtmSignEventBuilders';
export type { ConnectEmailSuccessArgs, SignUpSuccessArgs } from './gtmSignEventBuilders';
import {
  gtmClickEventVideoSignups,
  gtmClickHeaderSignups,
  gtmClickLeadsElements,
  gtmClickOverviewBannerSignups,
  gtmClickRegistrationBanner,
  gtmClickReportDownloads,
  gtmClickReportsSignups,
} from './gtmButton';
import {
  gtmClickEsyncConnect,
  gtmClickEsyncCta,
  gtmClickLoginCta,
  gtmEsyncDisconnectConfirm,
  gtmViewEsyncAlerts,
  gtmViewEsyncCta,
  gtmViewLoginCta,
} from './gtmEmailSync';
import { gtmContactFormSubmission, gtmFormSubmission } from './gtmFormSubmission';
import { gtmSubmissionLeadsForm } from './gtmLeadsForm';
import { gtmViewLeadsForm } from './gtmLeadsForm';
import { gtmInteractionLeadsForm } from './gtmLeadsForm';
import { gtmClickNavigationItem, gtmClickNavigationOpen } from './gtmNavigation';
import {
  gtmClickEmailCta,
  gtmClickNotified,
  gtmResubSummaryToggle,
  gtmUnsubSummaryEmail,
  gtmViewNotified,
} from './gtmNotification';
import {
  gtmBasicDetailsSuccess,
  gtmClickJoinUsPmc,
  gtmClickSkipLinkedIn,
  gtmLinkedInFollowSuccess,
  gtmOnboardingPopUpDelay,
  gtmSignUpSuccessPmc,
  gtmViewBasicDetails,
  gtmViewJoinUsPmc,
  gtmViewLinkedIn,
} from './gtmOnboardingPopUp';
import { gtmSessions } from './gtmSessions';
import {
  gtmClickCourierSite,
  gtmClickFilter,
  gtmClickJoinUs,
  gtmClickParcel,
  gtmClickPlus,
  gtmClickPmc,
  gtmClickRemoveParcel,
  gtmClickSort,
  gtmClickUnsubAllConfirm,
  gtmImmediateFound,
  gtmImmediateNotFound,
  gtmInvalidParcelSearches,
  gtmParcelSearches,
  gtmParcelSearchesResult,
  gtmRemoveParcelConfirm,
  gtmUserSuggest,
  gtmUserSuggestFound,
  gtmViewGrantAccessPopup,
  gtmViewJoinUs,
  gtmViewParcel,
} from './gtmTracking';
import { gtmTrackingWidget } from './gtmTrackingWidget';
import {
  gtmBrowserVerificationClicks,
  gtmTrackingClickBrowserVerification,
  gtmVerificationPopupViews,
  gtmViewBrowserVerification,
} from './gtmVerify';

export {
  gtmFormSubmission,
  gtmContactFormSubmission,
  gtmOnboardingPopUpDelay,
  gtmLinkedInFollowSuccess,
  gtmBasicDetailsSuccess,
  gtmClickSkipLinkedIn,
  gtmViewBasicDetails,
  gtmViewLinkedIn,
  gtmViewJoinUsPmc,
  gtmSignUpSuccessPmc,
  gtmClickJoinUsPmc,
  gtmTrackingWidget,
  gtmVerificationPopupViews,
  gtmBrowserVerificationClicks,
  gtmClickCourierSite,
  gtmImmediateFound,
  gtmImmediateNotFound,
  gtmParcelSearches,
  gtmParcelSearchesResult,
  gtmInvalidParcelSearches,
  gtmClickParcel,
  gtmUserSuggest,
  gtmUserSuggestFound,
  gtmClickPmc,
  gtmClickRemoveParcel,
  gtmRemoveParcelConfirm,
  gtmClickFilter,
  gtmClickSort,
  gtmClickPlus,
  gtmViewParcel,
  gtmViewLeadsForm,
  gtmClickNavigationOpen,
  gtmClickNavigationItem,
  gtmClickRegistrationBanner,
  gtmClickReportsSignups,
  gtmClickReportDownloads,
  gtmClickEventVideoSignups,
  gtmClickHeaderSignups,
  gtmClickLeadsElements,
  gtmClickOverviewBannerSignups,
  // Leads Form
  gtmInteractionLeadsForm,
  // PMT
  gtmViewJoinUs,
  gtmClickJoinUs,
  gtmViewNotified,
  gtmClickNotified,
  gtmClickUnsubAllConfirm,
  gtmClickEmailCta,
  gtmViewBrowserVerification,
  gtmTrackingClickBrowserVerification,
  gtmSubmissionLeadsForm,
  gtmSessions,
  gtmUnsubSummaryEmail,
  gtmResubSummaryToggle,
  // Email Sync
  gtmViewLoginCta,
  gtmClickLoginCta,
  gtmEsyncDisconnectConfirm,
  gtmClickEsyncConnect,
  gtmViewEsyncCta,
  gtmClickEsyncCta,
  gtmViewEsyncAlerts,
  gtmViewGrantAccessPopup,
  // Affiliate
  gtmViewAffiliateSection,
  gtmAffiliateProductClick,
};
